import React from 'react';

const Navbar = ({ toggleSidebar }) => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container-fluid">
        <button type="button" onClick={toggleSidebar} className="btn btn-primary">
          <i className="fas fa-align-left"></i>
        </button>
        <div className="mx-auto">
          <a className="navbar-brand" href="/">Gym CRM</a>
        </div>
        <div className="d-flex align-items-center">
          <span className="me-2">Admin</span>
          <i className="fas fa-user-circle fa-2x"></i>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;